const STORAGE_KEY = "shuttlescore.roomCreatorSecrets.v1";

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writeAll(data) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

/**
 * Device-local copy of codes entered at create (Firestore private/access is not client-readable).
 * @param {string} uid
 * @param {string} roomCode
 * @param {{ refCode?: string; viewCode?: string }} secrets
 */
export function saveCreatorRoomSecrets(uid, roomCode, secrets) {
  if (!uid || !roomCode) return;
  const refCode = (secrets?.refCode || "").trim();
  const viewCode = (secrets?.viewCode || "").trim();
  if (!refCode && !viewCode) return;
  const all = readAll();
  const byUser = all[uid] && typeof all[uid] === "object" ? { ...all[uid] } : {};
  byUser[roomCode] = {
    refCode,
    viewCode,
    savedAt: Date.now(),
  };
  all[uid] = byUser;
  writeAll(all);
}

/**
 * @param {string} uid
 * @param {string} roomCode
 * @returns {{ refCode: string; viewCode: string } | null}
 */
export function readCreatorRoomSecrets(uid, roomCode) {
  if (!uid || !roomCode) return null;
  const entry = readAll()[uid]?.[roomCode];
  if (!entry || typeof entry !== "object") return null;
  return {
    refCode: (entry.refCode || "").trim(),
    viewCode: (entry.viewCode || "").trim(),
  };
}

export function clearCreatorRoomSecrets(uid, roomCode) {
  if (!uid || !roomCode) return;
  const all = readAll();
  const byUser = all[uid];
  if (!byUser || typeof byUser !== "object") return;
  const next = { ...byUser };
  delete next[roomCode];
  all[uid] = next;
  writeAll(all);
}
